import React from 'react';
import { SidePanelContentCardHelperContent } from '@brighterion/br-ui';
import ContentCardHelperTable from './ContentCardHelperTable';

const SidePanelContentCardHelper = ({ cardHelperData }: SidePanelContentCardHelperProps) => {
    const helperChildContent = {
        title: cardHelperData?.title,
        titleIcon: cardHelperData?.titleIcon,
        isError: cardHelperData?.isError
    };
    const { helperTableProps } = cardHelperData;
    return (
        <SidePanelContentCardHelperContent helperChildContent={helperChildContent}>
            {helperTableProps && <ContentCardHelperTable data={helperTableProps} />}
        </SidePanelContentCardHelperContent>
    );
};

export default SidePanelContentCardHelper;
